import React from 'react';

import '../../pages/Auth/styles.scss';
import bg from '../../img/auth-bg.png'

import { Logo } from '../../static';
import Footer from '../Footer';

export const withAuthLayout = (WrappedComponent) => {
	return () => (
		<>
			<div className="auth">
				<div className="auth__bg-wrapper">
					<img className="auth__bg" src={bg} alt="auth-background" />

				</div>
				<div className="container">
					<div className="auth__logo">
						<Logo />
					</div>
					<div className="auth__content-wrapper">
						<WrappedComponent />
					</div>
				</div>
				<Footer isFixBottom/>
			</div>
		</>
	);
};
